import React from 'react';
import { useChatStore } from '../stores/chat-store';

const ConfirmationButtons: React.FC = () => {
  const { sendMessage } = useChatStore();

  return (
    <div className="flex items-center gap-2 mt-2">
      <button
        aria-label="Confirm"
        className="px-3 py-1 text-sm font-medium rounded-md bg-success text-white hover:bg-success/90 transition-colors"
        onClick={() => sendMessage('Yes, confirm')}
      >
        Confirm
      </button>
      <button
        aria-label="Cancel"
        className="px-3 py-1 text-sm font-medium rounded-md bg-background-alt text-text-muted hover:bg-bronze-100 transition-colors"
        onClick={() => sendMessage('No, cancel')}
      >
        Cancel
      </button>
    </div>
  );
};

export default ConfirmationButtons;
